define('commons/wizard/wizard-page',['jquery'], function($) {
   
    /**
     * A WizardPage represents all the content of a page and is included in a Wizard.
     */
    var WizardPage = function( id, title, description, iconUrl, options ) {
        this.options = $.extend({
            hide : function( page, onPageHidden ) {
                page.$content.fadeOut('fast', onPageHidden);
            },
            show : function( page ) {
                page.$content.removeClass('hidden').fadeIn('fast');
            },
            showNextButton : function (){
                return true;
            },
            showPreviousButton : function (){
                return true;
            }
        }, options);

        this.id = '#' + id;
        this.title = title;
        this.description = description;
        this.iconUrl = iconUrl;
        this.$content = null;
        
        this._init( options );
    };
    
    WizardPage.prototype._init = function( options ){
        this.$content = $(this.id);
        
        // Bind hidden fields
        this.$content.find('[data-hidden-input-id]').on('click', function( event ){
            var $this = $(this);
            var inputId = $this.data('hiddenInputId');
            $('#' + inputId).val( $this.data('hiddenInputValue') );
        });
        
        // hidden by default
        this.hide();
    };
    
    WizardPage.prototype.show = function(){
        this.options.show( this );
    };
    
    WizardPage.prototype.hide= function( onPageHidden ){
        this.options.hide( this, onPageHidden );
    };
    
    WizardPage.prototype.hasErrors = function(){
        return this.$content.has('div.error').length > 0 ;
    };
    
    WizardPage.prototype.clearErrors = function(){
        var $errorDiv = this.$content.find('div.error');
        $errorDiv.remove();
    };
    
    return WizardPage;
});
